import * as React from 'react';
import { Text, Icon, IComboBoxOption, IPersonaSharedProps } from '@fluentui/react';
import { styles } from '../CalendarStyles';
import { Activity } from '../../../system/activity/Activity';
import CollaboratorActivity from '../../../system/collaborators/collaborator_activity/CollaboratorActivity';
import { Collaborator } from '../../../system/collaborators/Collaborator';
import TimeTaxSupportSystemClient from '../../../system';
import CollaboratorPersona from '../../Collaborator/CollaboratorPersona';
import { User } from '../../../system/User';
import { ActivityValidations } from './ActivityValidations';
import { ErrorIntermediate } from '../../Common/ErrorIntermediate';
import { useTranslation } from 'react-i18next';
import ComboBoxSearch from '../../Common/ComboBoxSearch';
import { ConfirmPreloadTeam } from '../../Proyectos/ProjectConfiguration/ConfirmPreloadTeam';

interface IActivityTeam {
  activity: Activity;
  edit: boolean;
  colaborators: Collaborator[];
  system: TimeTaxSupportSystemClient;
  user: User;
  updateActivity?: () => void;
  userLoggedIsOwner: boolean;
  validations?: ActivityValidations;
  submitted?: boolean;
  isShowDialogConfirm?:boolean;
}

export const ActivityTeam = (props: IActivityTeam) => {
  const collaboratorOptions = React.useMemo(() => {
    return props.colaborators;
  }, []);

  const { t, i18n } = useTranslation();
  const [textDropDown, setTextDropDown] = React.useState<string>('');
  const [showDialog, setShowDialog] = React.useState<boolean>(false);
  const [collaboratorAvailable, setColaboratorAvailable] = React.useState<CollaboratorActivity[]>(props.activity.getId() ? props.activity.getCollaboratorActivityList() : props.activity.getAttendeesList());
  const [collaboratorOptionsAvailable, setColaboratorAvailableOptions] = React.useState<Collaborator[]>(collaboratorOptions);
  const [collaboratorSearch, setCollaboratorSearch] = React.useState<CollaboratorActivity[]>([]);
  const [isDelete, setIsDelete] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (props.isShowDialogConfirm && !isDelete ) {
      setShowDialog(props.isShowDialogConfirm);
    } else {
      setIsDelete(false);
    }
  },[props.activity.getCollaboratorActivityList().length]);

  React.useEffect(() => {
    refreshAvailableOptions();
  }, [props.activity]);

  const refreshAvailableOptions = () => {
    let _collaboratorAvailableOptions: Collaborator[] = [];
    _collaboratorAvailableOptions = collaboratorOptions.filter((col) => {
      const isInTeam = collaboratorAvailable
          .find((colact) => colact.getCollaborator().isIdentifiedBy(col.getId()) && !colact.get__delete());
      if (!isInTeam) {
        return true;
      }
      return false;
    });

    setColaboratorAvailableOptions(_collaboratorAvailableOptions);
  };

  const onDeleteItem = (i: number) => {
    let _collaboratorActivityList = [...props.activity.getCollaboratorActivityList()];
    if (canDelete(_collaboratorActivityList[i])) {
      if (!_collaboratorActivityList[i].getId()) {
        deleteAttend(_collaboratorActivityList[i]);
        _collaboratorActivityList.splice(i, 1);
      } else {
        _collaboratorActivityList[i].set__delete(true);
      }
      props.activity.setCollaboratorActivityList(_collaboratorActivityList);
      setColaboratorAvailable(_collaboratorActivityList);
      if (props.updateActivity) props.updateActivity();
      // refreshAvailableOptions();
    }
    setShowDialog(false);
    setIsDelete(true);
  };

  const canDelete = (colact: CollaboratorActivity) => {
    return !props.user.getCollaborator().isIdentifiedAs(colact.getCollaborator());
  };

  const handleChangeColaborator2 = (option?: IComboBoxOption | undefined) => {
    setIsDelete(true);
    setTextDropDown('');
    if (option) {
      let _collaboratorActivityList = [...props.activity.getCollaboratorActivityList()];
      let col_id = option.key;
      const col = collaboratorOptions.find((col: Collaborator) => col.getId() === col_id);
      if (col) {
        let colToPush = CollaboratorActivity.getNewFromColaborador(
            props.system.getCollaboratorSystem(),
            col,
            props.activity.getHours(),
            false,
            true
        );
        _collaboratorActivityList.push(colToPush);
        props.activity.setCollaboratorActivityList(_collaboratorActivityList);
        setColaboratorAvailable(_collaboratorActivityList);
        setCollaboratorSearch((prev) => [...prev, colToPush]);
        if (props.updateActivity) props.updateActivity();
        // refreshAvailableOptions();
      }
    }
  };

  const isAconfirmedTag = (colact: CollaboratorActivity) => {
    return (
        (colact.getChecked() && colact.getDate_tag()) ||
        props.user.getCollaborator().isIdentifiedAs(colact.getCollaborator())
    );
  };

  const deleteAttend = (colab: CollaboratorActivity) => {
    const filteredList = props.activity.getAttendeesList().filter(
      item => item.getCollaborator().getId() !== colab.getCollaborator().getId()
    );

    props.activity.setAttendeesList(filteredList);
  }

  const preloadTeam = (confirm: boolean) => {
    if (confirm) {
      if (collaboratorSearch.length > 0) {
        let _collaboratorActivityList = [...props.activity.getCollaboratorActivityList(),...collaboratorSearch];
        props.activity.setCollaboratorActivityList(_collaboratorActivityList);
        setIsDelete(true);
        setCollaboratorSearch([]);
      }
      setColaboratorAvailable(props.activity.getCollaboratorActivityList());
    } else{
      deleteCollaboratorList();
      setIsDelete(true);
    }
    setShowDialog(false);
  }

  const countCollaboratorsNew = () => {
    const attendeesList = props.activity.getAttendeesList();
    const collaboratorActivityList = props.activity.getCollaboratorActivityList();

    let colaboratorFilter = collaboratorAvailable.filter(attendee =>
      attendeesList.some(collab =>
        collab.getCollaborator().getId() === attendee.getCollaborator().getId()
      )
    ).length;

    return collaboratorActivityList.length - colaboratorFilter;
  }

  const deleteCollaboratorList = () => {
    props.activity.setCollaboratorActivityList(collaboratorAvailable);
  }

  return (
      <div id="team-section">
        {props.edit /*&& props.activity.isNew()*/ ? (
            <>
              <Text block variant="medium" className={styles.subtitleCard}>
                {t('Equipo')}
              </Text>

              <Text block variant="large" className={`${styles.dropdownDocsCont} ade-field`}>
                <Icon iconName="Group" className={styles.iconForText} />

                <ComboBoxSearch
                    className={styles.inputDropdown}
                    disabled={!props.userLoggedIsOwner || props.activity.getCollaboratorActivityList().length === 0}
                    options={collaboratorOptionsAvailable.map((colOption: Collaborator) => {
                      let ret: IComboBoxOption = {
                        key: colOption.getId(),
                        text: colOption.fullName(),
                      };
                      return ret;
                    })}
                    selected={['-1']}
                    onSelectOption={(o) => handleChangeColaborator2(o)}
                    cleanOnSelect={true}
                ></ComboBoxSearch>
              </Text>

              {props.validations && (
                  <div className="ml-3">
                    <ErrorIntermediate
                        validation={props.validations.team}
                        submitted={!!props.submitted}
                        params={props.activity.getCollaboratorActivityList()}
                    ></ErrorIntermediate>
                  </div>
              )}

              <ConfirmPreloadTeam
                show={showDialog}
                collaborators={countCollaboratorsNew()}
                onClose={preloadTeam}
                textTitle='Quieres incluir en la actividad a todos los colaboradores que pertenecen al proyecto'
                nodeName={props.activity.getProject()?.getName() || ''}
              />
              <Text>
              {collaboratorAvailable &&
              collaboratorAvailable.map((colact: any, i) => {
                const PersonaData: IPersonaSharedProps = {
                  text: colact.getCollaborator().fullName(),
                };
                if (!colact.get__delete()) {
                  return (
                      <div key={i} className="mt-1 ade-row">
                        <div className={`${styles.sectionText} ade-row-text`}>
                          {colact?.getChecked()}
                          <CollaboratorPersona
                              collaborator={colact.getCollaborator()}
                              usePresenseForActivity={true}
                              dateTag={colact.getDate_tag()}
                              confirmedActivity={colact.getChecked()}
                          ></CollaboratorPersona>
                        </div>
                        <div className={`${styles.sectionDelete} ade-row-action`}>
                          {props.userLoggedIsOwner && !isAconfirmedTag(colact) && (
                              <Icon
                                  iconName="Trash"
                                  className={`${styles.iconDelete} ade-delete-icon`}
                                  onClick={() => onDeleteItem(i)}
                              />
                          )}
                        </div>
                      </div>
                  );
                }
              })}
              </Text>
            </>
        ) : (
            <div>
              <Text block variant="medium" className={styles.subtitleCard}>
                <Icon iconName="Group" className="text-icon" />
                {t('Equipo')}
              </Text>

              <Text>
                {props.activity.getCollaboratorActivityList() &&
                    props.activity.getCollaboratorActivityList().map((colact: CollaboratorActivity, i) => {
                      return (
                          <div key={i} className="mt-1">
                            <div className={styles.sectionText}>
                              <CollaboratorPersona
                                  collaborator={colact.getCollaborator()}
                                  usePresenseForActivity={true}
                                  dateTag={colact.getDate_tag()}
                                  confirmedActivity={colact.getChecked()}
                              ></CollaboratorPersona>
                            </div>
                          </div>
                      );
                    })}
              </Text>
            </div>
        )}
      </div>
  );
};
